const constantObj = {
  API_URL_PROD: "https://unbeatable-admin-1.onrender.com/unbeatabletechEa.API",
  API_URL_DEV: "https://unbeatable-admin-1.onrender.com/unbeatabletechEa.API",
  TIKTOK: "https://www.tiktok.com/@unbeatable_ea?_t=8qIHKDihpSf&_r=1",
  TELEGRAM: "https://t.me/+MOrdCEsvaCFlMDBk",
  INSTAGRAM:
    "https://www.instagram.com/unbeatable_tech_guy/profilecard/?igsh=eTE0NmQwZm1seWYw",
  FACEBOOK: "https://www.facebook.com/share/QkdLTK3HDvy1WpPH/?mibextid=qi2Omg",
  TWITTER: "https://x.com/Techintrodev?s=09",
  DISCORD: "https://discord.gg/uQA5D7Sd",

  FACEBOOK_CHANNEL: "https://www.facebook.com/sourcepro1?mibextid=ZbWKwL",
  BTC_WALLET: "1Myb5CCApr8Eodh2AmZpEMv5uKb2aMRsRR",
  USDT_WALLET: "TDBxPmYRrZdo5QjKjqcu5N3ysLnz7KweBj",
  ADMIN: "http://t.me/techintrodev",
};

export default constantObj;
